import { Box } from '@hopin-team/ui-box';
import styled from 'styled-components';

/**
 * The margin bottom is to help with showing
 * the action menu that's opening on the last row.
 */
export const Container = styled(Box).attrs({ mt: 3, mb: 8 })``;
